import { render, staticRenderFns } from "./DepositTerms.vue?vue&type=template&id=36172c56&scoped=true"
import script from "./DepositTerms.vue?vue&type=script&lang=js"
export * from "./DepositTerms.vue?vue&type=script&lang=js"
import style0 from "./DepositTerms.vue?vue&type=style&index=0&id=36172c56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36172c56",
  null
  
)

export default component.exports